import { css } from "@emotion/react";
import { constants, typographyStyles as Typography } from "@newsela/angelou";

/** Constants */

const angelouUI = constants.colors.ui;
const greyDark = angelouUI.neutral[600];

export const rowTitleCss = css`
  color: ${greyDark};
  display: inline-block;
  line-height: 1.33rem;
  /**
   * i dont this this is working as we want it to work. We probably want
   * to grab this from types instead
   */
  font-size: ${Typography.heading3Obj};
  font-weight: bold;
  margin: 16px 0 0 0;
  text-decoration: none;

  .user-is-tabbing &:focus-within {
    outline: 3px solid highlight;
    outline: 3px solid -webkit-focus-ring-color;
  }
`;
